import React from "react";
import "./SecondaryFooter.css";
import { Link } from 'react-router-dom';

const SecondaryFooter = () => {
  return (
    <footer className="calc-footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-section">
            <h4>About Us</h4>
            <p>
              Your all-in-one SEO marketplace for smarter growth and higher rankings
            </p>
          </div>

          <div className="footer-column">
            <h6>ELEXYT SEO</h6>
            <Link
              to="/"
              onClick={() => {
                setTimeout(() => {
                  const el = document.getElementById("products");
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                }, 200);
              }}
            >
              MarketPlace
            </Link>

            <Link to="/finance/sip">Financial Calculators</Link>
            <Link to="/contact">Free Demo</Link>
          </div>

          <div className="footer-column">
            <h6>COMPANY</h6>
            <a href="https://elexyt.com/" target="_blank" rel="noopener noreferrer">
              About Us
            </a>

            <Link to="/contact">
              Contact us
            </Link>
          </div>

          <div className="footer-column">
                      <h6>FOLLOW US</h6>
          
          
                      <Link
                        to="https://www.linkedin.com/company/104980686/admin/page-posts/published/"
                        className="d-flex align-items-center mb-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-linkedin me-2"></i> LinkedIn
                      </Link>
          
                      <Link
                        to="https://www.youtube.com/@ElexytTech"
                        className="d-flex align-items-center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-youtube me-2"></i> YouTube
                      </Link>
                      
                    </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>&copy; 2026 Elexyt Technologies Pvt. Ltd.. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default SecondaryFooter;